import {
  HEADER_NAME_SCREEN_ID,
  HEADER_NAME_USER_ID,
  HEADER_PROJECT_ID,
  PROJECT_ID,
  BIM_PROJECT_ID,
  SCREEN_ID,
  HEADER_SCREEN_ID
} from '@app/consts/env_consts';
import { checkEmptyValue } from '@app/utils/StringUtils';
import { AxiosHeaders } from 'axios';
import { UserUtils } from '../userinfo';

export function updateAuthorizationHeader(headers: AxiosHeaders) {
  const userInfo: any = UserUtils.get();
  // Auth is handled via HttpOnly cookie set by the BFF — no Bearer token needed
  headers.set(HEADER_NAME_USER_ID, checkEmptyValue(userInfo?.userId));
  headers.set(HEADER_NAME_SCREEN_ID, sessionStorage.getItem(SCREEN_ID) ?? '');
  headers.set(HEADER_SCREEN_ID, sessionStorage.getItem(SCREEN_ID) ?? '1');
  
  // Priority: Design Portal flow projectId > regular projectId
  const projectId = localStorage.getItem(BIM_PROJECT_ID) || localStorage.getItem(PROJECT_ID) || '';
  headers.set(HEADER_PROJECT_ID, projectId);
}
